import { gsap, ScrollTrigger } from 'gsap/all';

const Transitions = {
	common: function() {

		$('.fade-in').each(function(){

			let target = $(this);
      let startPos = target.data('start') || 'top 80%';
      let delay = target.data('delay') || 0;
      let duration = target.data('duration') || 0.6;
      let ease = target.data('ease') || 'power4.easeOut';

      let dist = target.data('dist')
      dist = (typeof dist === 'undefined') ? 12 : dist;

			let direction = target.data('horiz') ? {x: dist} : {y: dist}

			let tl = gsap.timeline({
        scrollTrigger: {
          trigger: this,
          start: startPos,
        }
      })

			let props = {
				duration: duration,
				opacity: 0,
				ease: ease,
				direction
			}

			tl.from(target, props, delay)
		})

		$('.stagger-wrap').each(function(){

			let target = $(this);
      let stagger = target.data('stagger-delay') || 0.24;
      let startPos = target.data('start') || 'top 80%';
      let delay = target.data('delay') || 0;
      let duration = target.data('duration') || 0.6;
      let ease = target.data('ease') || 'power4.easeOut';

      let y = target.data('y')
      y = (typeof y === 'undefined') ? 12 : y;

      let children = target.hasClass('all') ? target.find('> *') : target.find('.stagger-el');
      let [head, ...tail] = children;

      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: this,
          start: startPos,
        }
      })

      if($(children[0]).hasClass('ic-subheader')){
      	tl.from(head, {
	        duration: duration,
	        opacity: 0,
	        x: -y,
	        stagger: stagger,
	        ease: ease
	      }, delay)

	      tl.from(tail, {
	        duration: duration,
	        opacity: 0,
	        y: y,
	        stagger: stagger,
	        ease: ease
	      }, delay + 0.4)


      } else {
      	tl.from(children, {
	        duration: duration,
	        opacity: 0,
	        y: y,
	        stagger: stagger,
	        ease: ease
	      }, delay)
      }
    })	



    $('.double-image-wrap').each(function(){
    	let target = $(this);
      let stagger = target.data('stagger-delay') || 0.24;
      let startPos = target.data('start') || 'top 50%';
      let delay = target.data('delay') || 0;
      let duration = target.data('duration') || 1.2;
      let ease = target.data('ease') || 'power4.easeOut';
      let origin = target.data('origin') || '50% 50%';

      let children = target.find('.double-image');


      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: this,
          start: startPos,
        }
      })

      tl.from(children, {
        duration: duration,
        opacity: 0,
        stagger: stagger,
        ease: ease
      }, delay)

      tl.from(children.find('img'), {
        duration: duration,
        opacity: 0,
        scale: 1.06,
        // y: 12,
        transformOrigin: origin,
        stagger: stagger,
        ease: ease
      }, delay)



    })
	}
}

export default Transitions